type NavigateFn = (
  path: string,
  opts?: { replace?: boolean; state?: any }
) => void;

let navigatorRef: NavigateFn | undefined;

export function setNavigator(n: NavigateFn) {
  navigatorRef = n;
}

export function navigateTo(
  path: string,
  opts?: { replace?: boolean; state?: any }
) {
  if (typeof navigatorRef === "function") {
    navigatorRef(path, opts);
  } else {
    if (opts?.replace) window.location.replace(path);
    else window.location.assign(path);
  }
}
